import moment, {type Moment} from 'moment-timezone';

export const isRegistrationDateInTheFuture = (registrationDate: Moment): boolean => {
    const now = moment();
    const date = registrationDate.clone();
    return date.isAfter(now);
};
